import {useForm} from "react-hook-form"
import {User} from "dto/User"
import {useCallback, useEffect, useMemo} from "react"
import {useLocation, useNavigate} from "react-router-dom"
import {FormErrorBox} from "common/FormErrorBox"
import {useRegisterUser} from "hooks/query/user-query"
import {NotificationType, showNotification} from "common/Notification"
import axios, {AxiosError} from "axios"
import {ApiResponse} from "dto/ApiResponse"

type RegisterUserProps = {
    // close: () => void
    mode?: "register" | "update"
}

export function RegisterUser({mode = "register"}: RegisterUserProps) {
    const location = useLocation()
    const navigate = useNavigate()
    const registerMutate = useRegisterUser()
    const {register, handleSubmit, formState: {errors}, setFocus, watch, setValue, getValues} = useForm<User>()
    const submit = (value: User) => {
        registerMutate.mutate({
            username: value.username,
            firstName: value.firstName,
            lastName: value.lastName,
            email: value.email,
            enabled: value.enabled,
            emailVerified: true,
        }, {
            onSuccess: () => {
                showNotification("사용자를 등록하였습니다", NotificationType.SUCCESS)
                close()
            },
            onError: (e) => {
                if (axios.isAxiosError(e)) {
                    const err = e as AxiosError<ApiResponse<any>>
                    const msg = err.response?.data.message || "등록중 오류가 발생했습니다"
                    showNotification(msg)
                } else {
                    showNotification("사용자 추가를 진행하지 못했습니다")
                }
            }
        })
    }
    const close = useCallback(() => {
        const path = location.pathname.replace("/register", "")
        navigate(path)
    }, [location.pathname, navigate])

    const modeValues = useMemo(() => {
        const modeName = mode === "register" ? "추가" : "수정"
        const isUpdateMode = mode === "update"
        return {
            modeName,
            isUpdateMode,
        }
    }, [mode])

    useEffect(() => {
        setValue("enabled", true)
    }, [setValue])

    const enabled = watch("enabled") || false
    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="modal is-active">
                <div className="modal-background" onClick={() => close()}/>
                <div className="modal-card model-modal">
                    <header className="modal-card-head has-background-purple">
                        <p className="modal-card-title has-text-white">사용자 {modeValues.modeName}하기</p>
                        <div className="delete is-clickable" aria-label="close" onClick={() => close()}></div>
                    </header>
                    <section className="modal-card-body">
                        <div className="columns mb0 mt10">
                            <div className="column columns">
                                <div className=" stitlebox label">사용자 ID</div>
                                <div className="column">
                                    <input className="input" type="text" placeholder="사용자아이디"
                                           {...register("username",
                                               {
                                                   required: "사용자 아이디는 필수 입니다", pattern: {
                                                       value: /^[a-zA-Z0-9]{3,}$/g,
                                                       message: "영문숫자 포함 3글자 이상이어야합니다"
                                                   }
                                               },
                                           )}
                                    />
                                    <FormErrorBox error={errors.username}/>
                                </div>
                            </div>
                        </div>
                        <div className="columns mb0 mt10">
                            <div className="column columns">
                                <div className=" stitlebox label">이름(First Name)</div>
                                <div className="column">
                                    <input className="input" type="text" placeholder="이름"
                                           {...register("firstName", {required: "이름이 필요합니다"})}/>
                                    <FormErrorBox error={errors.firstName}/>
                                </div>
                            </div>
                        </div>
                        <div className="columns mb0 mt10">
                            <div className="column columns">
                                <div className=" stitlebox label">성(Last Name)</div>
                                <div className="column">
                                    <input className="input" type="text" placeholder="성"
                                           {...register("lastName")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="columns mb0 mt10">
                            <div className="column columns">
                                <div className=" stitlebox label">E-mail</div>
                                <div className="column">
                                    <input className="input" type="text" placeholder="e-mail"
                                           {...register("email")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="columns mb0 mt10">
                            <div className="column columns">
                                <div className=" stitlebox label">사용자 활성화</div>
                                <div className="column ">
                                    <div className="tags has-addons mt-1">
                                        <div className={`btn-check is-clickable ${enabled ? "check-on" : ""}`}
                                             onClick={() => setValue("enabled", !getValues("enabled"))}>
                                            <div className="btn-select pl-1">{enabled ? "on" : "off"}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <footer className="modal-card-foot">
                        <button className="button is-purple2"> 사용자 추가</button>
                        <div className="button is-clickable" onClick={() => close()}>취소</div>
                    </footer>
                </div>
            </div>
        </form>
    )
}